import calendarHelper from "../../helpers/calendar.js";

const getDefaultState = () => {
  return {
		events: [],
		fetchedData: {},
  };
};

const state = getDefaultState();

const getters = {
	getCouncilCalendarEvents: (state) => state.events,
};

const actions = {
	async fetchCouncilCalendarData({ commit, state }, { month, year }) {
		const events = await calendarHelper.fetchCalendarData('council', state, month, year);
		if (events) {
			commit("addCouncilEvents", events.filter(event => event !== undefined));
		}
	},
	resetCouncilCalendarState ({ commit }) {
    commit('resetCouncilCalendarState');
  },
};

const mutations = {
	addCouncilEvents: (state, events) => (state.events = state.events.concat(events)),
	resetCouncilCalendarState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  }
};

export default { state, getters, actions, mutations };
